export class NeverError extends Error {
	constructor(public readonly value: never, comment: string = "") {
		super(comment);
	}

}
